export default __webpack_public_path__ + "assets/facilities-main.3e52e0fd.png";